// extracted by mini-css-extract-plugin
export default {"logo":"Login_logo__W+opJ","main":"Login_main__DVK0g","cta":"Login_cta__aJD+N"};